import { defineStore } from 'pinia'

const useShippingInquiryStore = defineStore('shippingInquiry', {
  state: () => ({}),
  actions: {},
})

export default useShippingInquiryStore
